"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const images_1 = require("../../../assets/images");
const components_1 = require("../../../components");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const constants_1 = require("../../../constants");
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const scale_1 = require("../../../utils/scale");
const react_redux_1 = require("react-redux");
const FollowUser = (props) => {
    const { item, onPress, handleFollowUser } = props;
    const buttonUnFollowRef = (0, react_1.useRef)(null);
    const isFollowed = item.is_followed == 1;
    const dataUser = (0, react_redux_1.useSelector)((state) => state?.loginReducer?.dataProfile, react_redux_1.shallowEqual);
    const navigateToUserProfile = () => {
        (0, rootNavigation_1.push)(Routes_1.default.USER_PROFILE, {
            userHandle: item.user_handle,
        });
    };
    return (react_1.default.createElement(react_native_1.View, { style: styles.mainItem },
        react_1.default.createElement(react_native_1.Pressable, { onPress: navigateToUserProfile },
            react_1.default.createElement(react_native_1.Image, { source: item.thumbnail_url ? { uri: item.thumbnail_url } : images_1.images?.AvatarDefaul, style: styles.avatar })),
        react_1.default.createElement(react_native_1.View, { style: { marginLeft: (0, scale_1.scale)(8), flex: 1 } },
            react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles.nickname, numberOfLines: 1, onPress: navigateToUserProfile }, item?.nickname || constants_1.DEFAULT_NAME),
            react_1.default.createElement(CustomText_1.default, { style: styles.userHandle, numberOfLines: 1, onPress: navigateToUserProfile }, `@${item?.user_handle}`),
            !!item.biography && (react_1.default.createElement(CustomText_1.default, { numberOfLines: 3, style: styles.biography }, item?.biography))),
        dataUser?.user_id == item?.user_id ? null :
            (isFollowed ? (react_1.default.createElement(react_native_1.TouchableOpacity, { ref: buttonUnFollowRef, style: [styles.button, { backgroundColor: '#DDDDDD' }], onPress: (event) => {
                    const position = buttonUnFollowRef.current?.getBoundingClientRect();
                    onPress(event, item, position);
                } },
                react_1.default.createElement(CustomText_1.default, { style: styles.buttonLabel }, "\u30D5\u30A9\u30ED\u30FC\u4E2D"))) : (react_1.default.createElement(components_1.LinearButton, { title: "\u30D5\u30A9\u30ED\u30FC", textStyle: [styles.buttonLabel, { color: '#FEFEFE' }], style: styles.button, onPress: () => handleFollowUser(item.user_id) })))));
};
exports.default = FollowUser;
const styles = react_native_1.StyleSheet.create({
    avatar: {
        height: (0, scale_1.scale)(42),
        width: (0, scale_1.scale)(42),
        borderRadius: 999,
    },
    nickname: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#292A33',
    },
    userHandle: {
        marginTop: (0, scale_1.scale)(4),
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(17),
        color: '#545454',
    },
    biography: {
        marginTop: (0, scale_1.scale)(4),
        fontSize: (0, scale_1.moderateScale)(12),
        lineHeight: (0, scale_1.moderateScale)(18),
        color: '#545454',
    },
    mainItem: {
        width: '100%',
        justifyContent: 'space-between',
        paddingHorizontal: (0, scale_1.scale)(16),
        paddingVertical: (0, scale_1.scale)(12),
        flexDirection: 'row',
        borderBottomColor: '#dddddd',
        borderBottomWidth: (0, scale_1.scale)(1),
    },
    button: {
        width: (0, scale_1.scale)(96),
        height: (0, scale_1.scale)(32),
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: (0, scale_1.scale)(4),
    },
    buttonLabel: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#545454',
    },
});
